import React from 'react';
import ImportContainer from '../../common/DataImport/ImportContainer';
import { employeeToProjectConfig } from '../configs/employeeToProjectConfig';

const ImportEmployeeToProject = () => {
  return (
    <ImportContainer
        config={employeeToProjectConfig}
        title="Import Individual to Project"
        backPath="/data-import"
        backLabel="Back to Data Import"
    />
  );
};

export default ImportEmployeeToProject; 